export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "UU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "UU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "OU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "UU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "UU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "UU",
	},
	rattata: {
		tier: "LC",
	},
	rattataalola: {
		tier: "LC",
	},
	raticate: {
		tier: "UU",
	},
	raticatealola: {
		tier: "UU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "UU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "UU",
	},
	pichu: {
		tier: "LC",
	},
	pichuspikyeared: {
		tier: "Illegal",
	},
	pikachu: {
		tier: "NFE",
	},
	pikachucosplay: {
		tier: "Illegal",
	},
	pikachurockstar: {
		tier: "Illegal",
	},
	pikachubelle: {
		tier: "Illegal",
	},
	pikachupopstar: {
		tier: "Illegal",
	},
	pikachuphd: {
		tier: "Illegal",
	},
	pikachulibre: {
		tier: "Illegal",
	},
	pikachuoriginal: {
		tier: "UU",
	},
	pikachuhoenn: {
		tier: "UU",
	},
	pikachusinnoh: {
		tier: "UU",
	},
	pikachuunova: {
		tier: "UU",
	},
	pikachukalos: {
		tier: "UU",
	},
	pikachualola: {
		tier: "UU",
	},
	pikachupartner: {
		tier: "UU",
	},
	pikachuworld: {
		tier: "UU",
	},
	raichu: {
		tier: "UU",
	},
	raichualola: {
		tier: "UU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandshrewalola: {
		tier: "LC",
	},
	sandslash: {
		tier: "UU",
	},
	sandslashalola: {
		tier: "UU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "UU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "UU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		tier: "UU",
	},
	vulpix: {
		tier: "LC",
	},
	vulpixalola: {
		tier: "LC",
	},
	ninetales: {
		tier: "UU",
	},
	ninetalesalola: {
		tier: "UU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "UU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NFE",
	},
	crobat: {
		tier: "UU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "UU",
	},
	bellossom: {
		tier: "UU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "UU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "UU",
	},
	diglett: {
		tier: "LC",
	},
	diglettalola: {
		tier: "LC",
	},
	dugtrio: {
		tier: "UU",
	},
	dugtrioalola: {
		tier: "UU",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		tier: "LC",
	},
	meowthgalar: {
		tier: "LC",
	},
	persian: {
		tier: "UU",
	},
	persianalola: {
		tier: "UU",
	},
	perrserker: {
		tier: "UU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "UU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "UU",
	},
	growlithe: {
		tier: "LC",
	},
	growlithehisui: {
		isNonstandard: null,
		tier: "LC",
	},
	arcanine: {
		tier: "UU",
	},
	arcaninehisui: {
		isNonstandard: null,
		tier: "UU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "UU",
	},
	politoed: {
		tier: "UU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		tier: "UU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "UU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "UU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "UU",
	},
	geodude: {
		tier: "LC",
	},
	geodudealola: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	graveleralola: {
		tier: "NFE",
	},
	golem: {
		tier: "UU",
	},
	golemalola: {
		tier: "UU",
	},
	ponyta: {
		tier: "LC",
	},
	ponytagalar: {
		tier: "LC",
	},
	rapidash: {
		tier: "UU",
	},
	rapidashgalar: {
		tier: "UU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowpokegalar: {
		tier: "LC",
	},
	slowbro: {
		tier: "UU",
	},
	slowbrogalar: {
		tier: "UU",
	},
	slowking: {
		tier: "UU",
	},
	slowkinggalar: {
		tier: "UU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "NFE",
	},
	magnezone: {
		tier: "UU",
	},
	farfetchd: {
		tier: "UU",
	},
	farfetchdgalar: {
		tier: "LC",
	},
	sirfetchd: {
		tier: "UU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "UU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "UU",
	},
	grimer: {
		tier: "LC",
	},
	grimeralola: {
		tier: "LC",
	},
	muk: {
		tier: "UU",
	},
	mukalola: {
		tier: "UU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "Uber",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NFE",
	},
	gengar: {
		tier: "UU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "UU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "UU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "UU",
	},
	voltorb: {
		tier: "LC",
	},
	voltorbhisui: {
		isNonstandard: null,
		tier: "LC",
	},
	electrode: {
		tier: "UU",
	},
	electrodehisui: {
		isNonstandard: null,
		tier: "OU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "UU",
	},
	exeggutoralola: {
		tier: "UU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "UU",
	},
	marowakalola: {
		tier: "UU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "UU",
	},
	hitmonchan: {
		tier: "UU",
	},
	hitmontop: {
		tier: "UU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		tier: "UU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "UU",
	},
	weezinggalar: {
		tier: "UU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "NFE",
	},
	rhyperior: {
		tier: "UU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "OU",
	},
	blissey: {
		tier: "UU",
	},
	tangela: {
		tier: "NFE",
	},
	tangrowth: {
		tier: "UU",
	},
	kangaskhan: {
		tier: "UU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "UU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "UU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		tier: "UU",
	},
	mrmimegalar: {
		tier: "NFE",
	},
	mrrime: {
		tier: "UU",
	},
	scyther: {
		tier: "NFE",
	},
	scizor: {
		tier: "UU",
	},
	kleavor: {
		isNonstandard: null,
		tier: "UU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "UU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		tier: "UU",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		tier: "UU",
	},
	pinsir: {
		tier: "UU",
	},
	tauros: {
		tier: "UU",
	},
	taurospaldeacombat: {
		tier: "UU",
	},
	taurospaldeablaze: {
		tier: "UU",
	},
	taurospaldeaaqua: {
		tier: "UU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
	},
	lapras: {
		tier: "UU",
	},
	ditto: {
		tier: "UU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "UU",
	},
	jolteon: {
		tier: "UU",
	},
	flareon: {
		tier: "UU",
	},
	espeon: {
		tier: "UU",
	},
	umbreon: {
		tier: "UU",
	},
	leafeon: {
		tier: "UU",
	},
	glaceon: {
		tier: "UU",
	},
	sylveon: {
		tier: "UU",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		tier: "NFE",
	},
	porygonz: {
		tier: "UU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "Uber",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "UU",
	},
	aerodactyl: {
		tier: "UU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		tier: "UU",
	},
	articuno: {
		tier: "UU",
	},
	articunogalar: {
		tier: "UU",
	},
	zapdos: {
		tier: "UU",
	},
	zapdosgalar: {
		tier: "UU",
	},
	moltres: {
		tier: "UU",
	},
	moltresgalar: {
		tier: "UU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "UU",
	},
	mewtwo: {
		tier: "Uber",
	},
	mew: {
		tier: "Uber",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		tier: "UU",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		tier: "UU",
	},
	typhlosionhisui: {
		isNonstandard: null,
		tier: "UU",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		tier: "UU",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "UU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "UU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "UU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "UU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		tier: "UU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NFE",
	},
	togekiss: {
		tier: "UU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "UU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		tier: "UU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "UU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "UU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "UU",
	},
	aipom: {
		tier: "LC",
	},
	ambipom: {
		tier: "UU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "UU",
	},
	yanma: {
		tier: "LC",
	},
	yanmega: {
		tier: "UU",
	},
	wooper: {
		tier: "LC",
	},
	wooperpaldea: {
		tier: "LC",
	},
	quagsire: {
		tier: "UU",
	},
	murkrow: {
		tier: "LC",
	},
	honchkrow: {
		tier: "UU",
	},
	misdreavus: {
		tier: "LC",
	},
	mismagius: {
		tier: "UU",
	},
	unown: {
		tier: "UU",
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		tier: "UU",
	},
	girafarig: {
		tier: "NFE",
	},
	farigiraf: {
		tier: "UU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "UU",
	},
	dunsparce: {
		tier: "LC",
	},
	dudunsparce: {
		tier: "UU",
	},
	gligar: {
		tier: "LC",
	},
	gliscor: {
		tier: "UU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "UU",
	},
	qwilfish: {
		tier: "UU",
	},
	qwilfishhisui: {
		isNonstandard: null,
		tier: "NFE",
	},
	overqwil: {
		isNonstandard: null,
		tier: "UU",
	},
	shuckle: {
		tier: "UU",
	},
	heracross: {
		tier: "UU",
	},
	sneasel: {
		tier: "NFE",
	},
	sneaselhisui: {
		isNonstandard: null,
		tier: "NFE",
	},
	weavile: {
		tier: "UU",
	},
	sneasler: {
		isNonstandard: null,
		tier: "OU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "UU",
	},
	ursaluna: {
		isNonstandard: null,
		tier: "OU",
	},
	ursalunabloodmoon: {
		tier: "UU",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "UU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NFE",
	},
	mamoswine: {
		tier: "UU",
	},
	corsola: {
		tier: "UU",
	},
	corsolagalar: {
		tier: "LC",
	},
	cursola: {
		tier: "UU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "UU",
	},
	delibird: {
		tier: "UU",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		tier: "UU",
	},
	skarmory: {
		tier: "UU",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		tier: "UU",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UU",
	},
	stantler: {
		tier: "NFE",
	},
	wyrdeer: {
		isNonstandard: null,
		tier: "UU",
	},
	smeargle: {
		tier: "UU",
	},
	miltank: {
		tier: "UU",
	},
	raikou: {
		tier: "UU",
	},
	entei: {
		tier: "UU",
	},
	suicune: {
		tier: "UU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "UU",
	},
	lugia: {
		tier: "Uber",
	},
	hooh: {
		tier: "Uber",
	},
	celebi: {
		tier: "UU",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		tier: "UU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		tier: "UU",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		tier: "UU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "UU",
	},
	zigzagoon: {
		tier: "LC",
	},
	zigzagoongalar: {
		tier: "LC",
	},
	linoone: {
		tier: "UU",
	},
	linoonegalar: {
		tier: "NFE",
	},
	obstagoon: {
		tier: "UU",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		tier: "UU",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		tier: "UU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		tier: "UU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "UU",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		tier: "UU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "UU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "UU",
	},
	gallade: {
		tier: "UU",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "UU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "UU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NFE",
	},
	slaking: {
		tier: "Uber",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "OU",
	},
	shedinja: {
		tier: "UU",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "UU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "UU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		tier: "UU",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		tier: "UU",
	},
	sableye: {
		tier: "UU",
	},
	mawile: {
		tier: "UU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		tier: "UU",
	},
	meditite: {
		tier: "LC",
	},
	medicham: {
		tier: "UU",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "UU",
	},
	plusle: {
		tier: "UU",
	},
	minun: {
		tier: "UU",
	},
	volbeat: {
		tier: "UU",
	},
	illumise: {
		tier: "UU",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "NFE",
	},
	roserade: {
		tier: "UU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "UU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "UU",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "UU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "UU",
	},
	torkoal: {
		tier: "UU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		tier: "UU",
	},
	spinda: {
		tier: "UU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		tier: "UU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "UU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "UU",
	},
	zangoose: {
		tier: "UU",
	},
	seviper: {
		tier: "UU",
	},
	lunatone: {
		tier: "UU",
	},
	solrock: {
		tier: "UU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "UU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "UU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "UU",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		tier: "UU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		tier: "UU",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "UU",
	},
	castform: {
		tier: "UU",
	},
	kecleon: {
		tier: "UU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		tier: "UU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		tier: "UU",
	},
	tropius: {
		tier: "UU",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		tier: "UU",
	},
	absol: {
		tier: "UU",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "UU",
	},
	froslass: {
		tier: "UU",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		tier: "UU",
	},
	clamperl: {
		tier: "LC",
	},
	huntail: {
		tier: "UU",
	},
	gorebyss: {
		tier: "Uber",
	},
	relicanth: {
		tier: "UU",
	},
	luvdisc: {
		tier: "UU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		tier: "UU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NFE",
	},
	metagross: {
		tier: "UU",
	},
	regirock: {
		tier: "UU",
	},
	regice: {
		tier: "UU",
	},
	registeel: {
		tier: "UU",
	},
	latias: {
		tier: "UU",
	},
	latios: {
		tier: "OU",
	},
	kyogre: {
		tier: "Uber",
	},
	groudon: {
		tier: "Uber",
	},
	rayquaza: {
		tier: "Uber",
	},
	rayquazamega: {
		tier: "Uber",
	},
	jirachi: {
		tier: "UU",
	},
	deoxys: {
		tier: "Uber",
	},
	deoxysattack: {
		tier: "Uber",
	},
	deoxysdefense: {
		tier: "UU",
	},
	deoxysspeed: {
		tier: "Uber",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		tier: "OU",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "NFE",
	},
	infernape: {
		tier: "UU",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		tier: "OU",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		tier: "UU",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		tier: "UU",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		tier: "UU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "UU",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		tier: "UU",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		tier: "UU",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		tier: "UU",
	},
	wormadamsandy: {
		tier: "UU",
	},
	wormadamtrash: {
		tier: "UU",
	},
	mothim: {
		tier: "UU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "UU",
	},
	pachirisu: {
		tier: "UU",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		tier: "UU",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		tier: "UU",
	},
	cherrimsunshine: {
		tier: "Illegal",
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "OU",
	},
	drifloon: {
		tier: "LC",
	},
	drifblim: {
		tier: "UU",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		tier: "UU",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		tier: "UU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "UU",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		tier: "UU",
	},
	chatot: {
		tier: "UU",
	},
	spiritomb: {
		tier: "UU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "UU",
	},
	garchomp: {
		tier: "OU",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "UU",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		tier: "UU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		tier: "UU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "UU",
	},
	carnivine: {
		tier: "UU",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		tier: "UU",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		tier: "UU",
	},
	rotom: {
		tier: "UU",
	},
	rotomheat: {
		tier: "UU",
	},
	rotomwash: {
		tier: "UU",
	},
	rotomfrost: {
		tier: "UU",
	},
	rotomfan: {
		tier: "UU",
	},
	rotommow: {
		tier: "UU",
	},
	uxie: {
		tier: "UU",
	},
	mesprit: {
		tier: "UU",
	},
	azelf: {
		tier: "OU",
	},
	dialga: {
		tier: "Uber",
	},
	dialgaorigin: {
		tier: "Illegal",
	},
	palkia: {
		tier: "Uber",
	},
	palkiaorigin: {
		tier: "Illegal",
	},
	heatran: {
		tier: "UU",
	},
	regigigas: {
		tier: "Uber",
	},
	giratina: {
		tier: "OU",
	},
	giratinaorigin: {
		tier: "Illegal",
	},
	cresselia: {
		tier: "UU",
	},
	phione: {
		tier: "UU",
	},
	manaphy: {
		tier: "UU",
	},
	darkrai: {
		tier: "Uber",
	},
	shaymin: {
		tier: "UU",
	},
	shayminsky: {
		tier: "UU",
	},
	arceus: {
		tier: "Uber",
	},
	victini: {
		tier: "OU",
	},
	snivy: {
		tier: "LC",
	},
	servine: {
		tier: "NFE",
	},
	serperior: {
		tier: "UU",
	},
	tepig: {
		tier: "LC",
	},
	pignite: {
		tier: "NFE",
	},
	emboar: {
		tier: "UU",
	},
	oshawott: {
		tier: "LC",
	},
	dewott: {
		tier: "NFE",
	},
	samurott: {
		tier: "UU",
	},
	samurotthisui: {
		isNonstandard: null,
		tier: "UU",
	},
	patrat: {
		tier: "LC",
	},
	watchog: {
		tier: "UU",
	},
	lillipup: {
		tier: "LC",
	},
	herdier: {
		tier: "NFE",
	},
	stoutland: {
		tier: "UU",
	},
	purrloin: {
		tier: "LC",
	},
	liepard: {
		tier: "UU",
	},
	pansage: {
		tier: "LC",
	},
	simisage: {
		tier: "UU",
	},
	pansear: {
		tier: "LC",
	},
	simisear: {
		tier: "UU",
	},
	panpour: {
		tier: "LC",
	},
	simipour: {
		tier: "UU",
	},
	munna: {
		tier: "LC",
	},
	musharna: {
		tier: "UU",
	},
	pidove: {
		tier: "LC",
	},
	tranquill: {
		tier: "NFE",
	},
	unfezant: {
		tier: "UU",
	},
	blitzle: {
		tier: "LC",
	},
	zebstrika: {
		tier: "UU",
	},
	roggenrola: {
		tier: "LC",
	},
	boldore: {
		tier: "NFE",
	},
	gigalith: {
		tier: "UU",
	},
	woobat: {
		tier: "LC",
	},
	swoobat: {
		tier: "UU",
	},
	drilbur: {
		tier: "LC",
	},
	excadrill: {
		tier: "UU",
	},
	audino: {
		tier: "UU",
	},
	timburr: {
		tier: "LC",
	},
	gurdurr: {
		tier: "NFE",
	},
	conkeldurr: {
		tier: "UU",
	},
	tympole: {
		tier: "LC",
	},
	palpitoad: {
		tier: "NFE",
	},
	seismitoad: {
		tier: "UU",
	},
	throh: {
		tier: "UU",
	},
	sawk: {
		tier: "UU",
	},
	sewaddle: {
		tier: "LC",
	},
	swadloon: {
		tier: "NFE",
	},
	leavanny: {
		tier: "UU",
	},
	venipede: {
		tier: "LC",
	},
	whirlipede: {
		tier: "NFE",
	},
	scolipede: {
		tier: "UU",
	},
	cottonee: {
		tier: "LC",
	},
	whimsicott: {
		tier: "UU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		tier: "UU",
	},
	lilliganthisui: {
		isNonstandard: null,
		tier: "UU",
	},
	basculin: {
		tier: "UU",
	},
	basculinbluestriped: {
		tier: "UU",
	},
	basculinwhitestriped: {
		isNonstandard: null,
		tier: "NFE",
	},
	basculegion: {
		isNonstandard: null,
		tier: "UU",
	},
	basculegionf: {
		isNonstandard: null,
		tier: "UU",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "NFE",
	},
	krookodile: {
		tier: "UU",
	},
	darumaka: {
		tier: "LC",
	},
	darumakagalar: {
		tier: "LC",
	},
	darmanitan: {
		tier: "UU",
	},
	darmanitanzen: {
		tier: "Illegal",
	},
	darmanitangalar: {
		tier: "UU",
	},
	darmanitangalarzen: {
		tier: "Illegal",
	},
	maractus: {
		tier: "UU",
	},
	dwebble: {
		tier: "LC",
	},
	crustle: {
		tier: "UU",
	},
	scraggy: {
		tier: "LC",
	},
	scrafty: {
		tier: "UU",
	},
	sigilyph: {
		tier: "UU",
	},
	yamask: {
		tier: "LC",
	},
	yamaskgalar: {
		tier: "LC",
	},
	cofagrigus: {
		tier: "UU",
	},
	runerigus: {
		tier: "UU",
	},
	tirtouga: {
		tier: "LC",
	},
	carracosta: {
		tier: "UU",
	},
	archen: {
		tier: "LC",
	},
	archeops: {
		tier: "OU",
	},
	trubbish: {
		tier: "LC",
	},
	garbodor: {
		tier: "UU",
	},
	zorua: {
		tier: "LC",
	},
	zoruahisui: {
		isNonstandard: null,
		tier: "LC",
	},
	zoroark: {
		tier: "UU",
	},
	zoroarkhisui: {
		isNonstandard: null,
		tier: "UU",
	},
	minccino: {
		tier: "LC",
	},
	cinccino: {
		tier: "UU",
	},
	gothita: {
		tier: "LC",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		tier: "UU",
	},
	solosis: {
		tier: "LC",
	},
	duosion: {
		tier: "NFE",
	},
	reuniclus: {
		tier: "UU",
	},
	ducklett: {
		tier: "LC",
	},
	swanna: {
		tier: "UU",
	},
	vanillite: {
		tier: "LC",
	},
	vanillish: {
		tier: "NFE",
	},
	vanilluxe: {
		tier: "UU",
	},
	deerling: {
		tier: "LC",
	},
	sawsbuck: {
		tier: "UU",
	},
	emolga: {
		tier: "UU",
	},
	karrablast: {
		tier: "LC",
	},
	escavalier: {
		tier: "UU",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		tier: "UU",
	},
	frillish: {
		tier: "LC",
	},
	jellicent: {
		tier: "UU",
	},
	alomomola: {
		tier: "UU",
	},
	joltik: {
		tier: "LC",
	},
	galvantula: {
		tier: "UU",
	},
	ferroseed: {
		tier: "LC",
	},
	ferrothorn: {
		tier: "UU",
	},
	klink: {
		tier: "LC",
	},
	klang: {
		tier: "UU",
	},
	klinklang: {
		tier: "UU",
	},
	tynamo: {
		tier: "LC",
	},
	eelektrik: {
		tier: "NFE",
	},
	eelektross: {
		tier: "UU",
	},
	elgyem: {
		tier: "LC",
	},
	beheeyem: {
		tier: "UU",
	},
	litwick: {
		tier: "LC",
	},
	lampent: {
		tier: "NFE",
	},
	chandelure: {
		tier: "UU",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "NFE",
	},
	haxorus: {
		tier: "UU",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		tier: "UU",
	},
	cryogonal: {
		tier: "UU",
	},
	shelmet: {
		tier: "LC",
	},
	accelgor: {
		tier: "UU",
	},
	stunfisk: {
		tier: "UU",
	},
	stunfiskgalar: {
		tier: "UU",
	},
	mienfoo: {
		tier: "LC",
	},
	mienshao: {
		tier: "UU",
	},
	druddigon: {
		tier: "UU",
	},
	golett: {
		tier: "LC",
	},
	golurk: {
		tier: "UU",
	},
	pawniard: {
		tier: "LC",
	},
	bisharp: {
		tier: "UU",
	},
	bouffalant: {
		tier: "UU",
	},
	rufflet: {
		tier: "LC",
	},
	braviary: {
		tier: "UU",
	},
	braviaryhisui: {
		isNonstandard: null,
		tier: "UU",
	},
	vullaby: {
		tier: "LC",
	},
	mandibuzz: {
		tier: "UU",
	},
	heatmor: {
		tier: "UU",
	},
	durant: {
		tier: "UU",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "NFE",
	},
	hydreigon: {
		tier: "UU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		tier: "UU",
	},
	cobalion: {
		tier: "UU",
	},
	terrakion: {
		tier: "UU",
	},
	virizion: {
		tier: "UU",
	},
	tornadus: {
		tier: "UU",
	},
	tornadustherian: {
		tier: "UU",
	},
	thundurus: {
		tier: "UU",
	},
	thundurustherian: {
		tier: "UU",
	},
	reshiram: {
		tier: "Uber",
	},
	zekrom: {
		tier: "Uber",
	},
	landorus: {
		tier: "UU",
	},
	landorustherian: {
		tier: "OU",
	},
	kyurem: {
		tier: "OU",
	},
	kyuremblack: {
		tier: "Uber",
	},
	kyuremwhite: {
		tier: "Uber",
	},
	keldeo: {
		tier: "UU",
	},
	keldeoresolute: {
		tier: "UU",
	},
	meloetta: {
		tier: "UU",
	},
	meloettapirouette: {
		tier: "UU",
	},
	genesect: {
		tier: "OU",
	},
	genesectburn: {
		tier: "Illegal",
	},
	genesectchill: {
		tier: "Illegal",
	},
	genesectdouse: {
		tier: "Illegal",
	},
	genesectshock: {
		tier: "Illegal",
	},
	chespin: {
		tier: "LC",
	},
	quilladin: {
		tier: "NFE",
	},
	chesnaught: {
		tier: "UU",
	},
	fennekin: {
		tier: "LC",
	},
	braixen: {
		tier: "NFE",
	},
	delphox: {
		tier: "UU",
	},
	froakie: {
		tier: "LC",
	},
	frogadier: {
		tier: "NFE",
	},
	greninja: {
		tier: "UU",
	},
	greninjaash: {
		tier: "Illegal",
	},
	bunnelby: {
		tier: "LC",
	},
	diggersby: {
		tier: "UU",
	},
	fletchling: {
		tier: "LC",
	},
	fletchinder: {
		tier: "NFE",
	},
	talonflame: {
		tier: "UU",
	},
	scatterbug: {
		tier: "LC",
	},
	spewpa: {
		tier: "NFE",
	},
	vivillon: {
		tier: "UU",
	},
	vivillonfancy: {
		tier: "UU",
	},
	vivillonpokeball: {
		tier: "UU",
	},
	litleo: {
		tier: "LC",
	},
	pyroar: {
		tier: "UU",
	},
	flabebe: {
		tier: "LC",
	},
	floette: {
		tier: "NFE",
	},
	floetteeternal: {
		tier: "UU",
	},
	florges: {
		tier: "UU",
	},
	skiddo: {
		tier: "LC",
	},
	gogoat: {
		tier: "UU",
	},
	pancham: {
		tier: "LC",
	},
	pangoro: {
		tier: "UU",
	},
	furfrou: {
		tier: "UU",
	},
	espurr: {
		tier: "LC",
	},
	meowstic: {
		tier: "UU",
	},
	meowsticf: {
		tier: "UU",
	},
	honedge: {
		tier: "LC",
	},
	doublade: {
		tier: "NFE",
	},
	aegislash: {
		tier: "UU",
	},
	aegislashblade: {
	},
	spritzee: {
		tier: "LC",
	},
	aromatisse: {
		tier: "UU",
	},
	swirlix: {
		tier: "LC",
	},
	slurpuff: {
		tier: "UU",
	},
	inkay: {
		tier: "LC",
	},
	malamar: {
		tier: "UU",
	},
	binacle: {
		tier: "LC",
	},
	barbaracle: {
		tier: "UU",
	},
	skrelp: {
		tier: "LC",
	},
	dragalge: {
		tier: "UU",
	},
	clauncher: {
		tier: "LC",
	},
	clawitzer: {
		tier: "UU",
	},
	helioptile: {
		tier: "LC",
	},
	heliolisk: {
		tier: "UU",
	},
	tyrunt: {
		tier: "LC",
	},
	tyrantrum: {
		tier: "UU",
	},
	amaura: {
		tier: "LC",
	},
	aurorus: {
		tier: "UU",
	},
	hawlucha: {
		tier: "UU",
	},
	dedenne: {
		tier: "UU",
	},
	carbink: {
		tier: "UU",
	},
	goomy: {
		tier: "LC",
	},
	sliggoo: {
		tier: "NFE",
	},
	sliggoohisui: {
		isNonstandard: null,
		tier: "NFE",
	},
	goodra: {
		tier: "UU",
	},
	goodrahisui: {
		isNonstandard: null,
		tier: "OU",
	},
	klefki: {
		tier: "UU",
	},
	phantump: {
		tier: "LC",
	},
	trevenant: {
		tier: "UU",
	},
	pumpkaboo: {
		tier: "LC",
	},
	pumpkaboosmall: {
		tier: "LC",
	},
	pumpkaboolarge: {
		tier: "LC",
	},
	pumpkaboosuper: {
		tier: "LC",
	},
	gourgeist: {
		tier: "UU",
	},
	gourgeistsmall: {
		tier: "UU",
	},
	gourgeistlarge: {
		tier: "UU",
	},
	gourgeistsuper: {
		tier: "UU",
	},
	bergmite: {
		tier: "LC",
	},
	avalugg: {
		tier: "UU",
	},
	avalugghisui: {
		isNonstandard: null,
		tier: "UU",
	},
	noibat: {
		tier: "LC",
	},
	noivern: {
		tier: "UU",
	},
	xerneas: {
		tier: "Uber",
	},
	yveltal: {
		tier: "OU",
	},
	zygarde: {
		tier: "UU",
	},
	zygarde10: {
		tier: "UU",
	},
	zygardecomplete: {
		tier: "Illegal",
	},
	diancie: {
		tier: "UU",
	},
	hoopa: {
		tier: "UU",
	},
	hoopaunbound: {
		tier: "UU",
	},
	volcanion: {
		tier: "UU",
	},
	rowlet: {
		tier: "LC",
	},
	dartrix: {
		tier: "UU",
	},
	decidueye: {
		tier: "UU",
	},
	decidueyehisui: {
		isNonstandard: null,
		tier: "UU",
	},
	litten: {
		tier: "LC",
	},
	torracat: {
		tier: "NFE",
	},
	incineroar: {
		tier: "UU",
	},
	popplio: {
		tier: "LC",
	},
	brionne: {
		tier: "NFE",
	},
	primarina: {
		tier: "UU",
	},
	pikipek: {
		tier: "LC",
	},
	trumbeak: {
		tier: "NFE",
	},
	toucannon: {
		tier: "UU",
	},
	yungoos: {
		tier: "LC",
	},
	gumshoos: {
		tier: "UU",
	},
	grubbin: {
		tier: "LC",
	},
	charjabug: {
		tier: "NFE",
	},
	vikavolt: {
		tier: "UU",
	},
	crabrawler: {
		tier: "LC",
	},
	crabominable: {
		tier: "UU",
	},
	oricorio: {
		tier: "UU",
	},
	oricoriopompom: {
		tier: "UU",
	},
	oricoriopau: {
		tier: "UU",
	},
	oricoriosensu: {
		tier: "UU",
	},
	cutiefly: {
		tier: "LC",
	},
	ribombee: {
		tier: "UU",
	},
	rockruff: {
		tier: "LC",
	},
	rockruffdusk: {
		tier: "LC",
	},
	lycanroc: {
		tier: "UU",
	},
	lycanrocmidnight: {
		tier: "UU",
	},
	lycanrocdusk: {
		tier: "UU",
	},
	wishiwashi: {
		tier: "UU",
	},
	wishiwashischool: {
	},
	mareanie: {
		tier: "LC",
	},
	toxapex: {
		tier: "UU",
	},
	mudbray: {
		tier: "LC",
	},
	mudsdale: {
		tier: "UU",
	},
	dewpider: {
		tier: "LC",
	},
	araquanid: {
		tier: "UU",
	},
	fomantis: {
		tier: "LC",
	},
	lurantis: {
		tier: "UU",
	},
	morelull: {
		tier: "LC",
	},
	shiinotic: {
		tier: "UU",
	},
	salandit: {
		tier: "LC",
	},
	salazzle: {
		tier: "UU",
	},
	stufful: {
		tier: "LC",
	},
	bewear: {
		tier: "UU",
	},
	bounsweet: {
		tier: "LC",
	},
	steenee: {
		tier: "NFE",
	},
	tsareena: {
		tier: "UU",
	},
	comfey: {
		tier: "UU",
	},
	oranguru: {
		tier: "UU",
	},
	passimian: {
		tier: "UU",
	},
	wimpod: {
		tier: "LC",
	},
	golisopod: {
		tier: "OU",
	},
	sandygast: {
		tier: "LC",
	},
	palossand: {
		tier: "UU",
	},
	pyukumuku: {
		tier: "UU",
	},
	typenull: {
		tier: "NFE",
	},
	silvally: {
		tier: "UU",
	},
	silvallybug: {
		tier: "Illegal",
	},
	silvallydark: {
		tier: "Illegal",
	},
	silvallydragon: {
		tier: "Illegal",
	},
	silvallyelectric: {
		tier: "Illegal",
	},
	silvallyfairy: {
		tier: "Illegal",
	},
	silvallyfighting: {
		tier: "Illegal",
	},
	silvallyfire: {
		tier: "Illegal",
	},
	silvallyflying: {
		tier: "Illegal",
	},
	silvallyghost: {
		tier: "Illegal",
	},
	silvallygrass: {
		tier: "Illegal",
	},
	silvallyground: {
		tier: "Illegal",
	},
	silvallyice: {
		tier: "Illegal",
	},
	silvallypoison: {
		tier: "Illegal",
	},
	silvallypsychic: {
		tier: "Illegal",
	},
	silvallyrock: {
		tier: "Illegal",
	},
	silvallysteel: {
		tier: "Illegal",
	},
	silvallywater: {
		tier: "Illegal",
	},
	minior: {
		tier: "UU",
	},
	miniormeteor: {
	},
	komala: {
		tier: "UU",
	},
	turtonator: {
		tier: "UU",
	},
	togedemaru: {
		tier: "UU",
	},
	mimikyu: {
		tier: "UU",
	},
	bruxish: {
		tier: "UU",
	},
	drampa: {
		tier: "UU",
	},
	dhelmise: {
		tier: "UU",
	},
	jangmoo: {
		tier: "LC",
	},
	hakamoo: {
		tier: "NFE",
	},
	kommoo: {
		tier: "UU",
	},
	tapukoko: {
		tier: "OU",
	},
	tapulele: {
		tier: "UU",
	},
	tapubulu: {
		tier: "UU",
	},
	tapufini: {
		tier: "UU",
	},
	cosmog: {
		tier: "LC",
	},
	cosmoem: {
		tier: "NFE",
	},
	solgaleo: {
		tier: "Uber",
	},
	lunala: {
		tier: "Uber",
	},
	nihilego: {
		tier: "UU",
	},
	buzzwole: {
		tier: "UU",
	},
	pheromosa: {
		tier: "Uber",
	},
	xurkitree: {
		tier: "UU",
	},
	celesteela: {
		tier: "UU",
	},
	kartana: {
		tier: "OU",
	},
	guzzlord: {
		tier: "UU",
	},
	necrozma: {
		tier: "UU",
	},
	necrozmaduskmane: {
		tier: "Uber",
	},
	necrozmadawnwings: {
		tier: "Uber",
	},
	necrozmaultra: {
		tier: "Illegal",
	},
	magearna: {
		tier: "OU",
	},
	marshadow: {
		tier: "Uber",
	},
	poipole: {
		tier: "NFE",
	},
	naganadel: {
		tier: "Uber",
	},
	stakataka: {
		tier: "UU",
	},
	blacephalon: {
		tier: "UU",
	},
	zeraora: {
		tier: "OU",
	},
	meltan: {
		tier: "UU",
	},
	melmetal: {
		tier: "UU",
	},
	grookey: {
		tier: "LC",
	},
	thwackey: {
		tier: "UU",
	},
	rillaboom: {
		tier: "UU",
	},
	scorbunny: {
		tier: "LC",
	},
	raboot: {
		tier: "NFE",
	},
	cinderace: {
		tier: "UU",
	},
	sobble: {
		tier: "LC",
	},
	drizzile: {
		tier: "NFE",
	},
	inteleon: {
		tier: "Uber",
	},
	skwovet: {
		tier: "LC",
	},
	greedent: {
		tier: "UU",
	},
	rookidee: {
		tier: "LC",
	},
	corvisquire: {
		tier: "NFE",
	},
	corviknight: {
		tier: "OU",
	},
	blipbug: {
		tier: "LC",
	},
	dottler: {
		tier: "NFE",
	},
	orbeetle: {
		tier: "LC",
	},
	nickit: {
		tier: "LC",
	},
	thievul: {
		tier: "UU",
	},
	gossifleur: {
		tier: "LC",
	},
	eldegoss: {
		tier: "UU",
	},
	wooloo: {
		tier: "LC",
	},
	dubwool: {
		tier: "UU",
	},
	chewtle: {
		tier: "LC",
	},
	drednaw: {
		tier: "UU",
	},
	yamper: {
		tier: "LC",
	},
	boltund: {
		tier: "UU",
	},
	rolycoly: {
		tier: "LC",
	},
	carkol: {
		tier: "NFE",
	},
	coalossal: {
		tier: "UU",
	},
	applin: {
		tier: "LC",
	},
	flapple: {
		tier: "UU",
	},
	appletun: {
		tier: "UU",
	},
	dipplin: {
		tier: "NFE",
	},
	silicobra: {
		tier: "LC",
	},
	sandaconda: {
		tier: "UU",
	},
	cramorant: {
		tier: "UU",
	},
	cramorantgorging: {
		tier: "Illegal",
	},
	cramorantgulping: {
		tier: "Illegal",
	},
	arrokuda: {
		tier: "LC",
	},
	barraskewda: {
		tier: "UU",
	},
	toxel: {
		tier: "LC",
	},
	toxtricity: {
		tier: "UU",
	},
	toxtricitylowkey: {
		tier: "UU",
	},
	sizzlipede: {
		tier: "LC",
	},
	centiskorch: {
		tier: "UU",
	},
	clobbopus: {
		tier: "LC",
	},
	grapploct: {
		tier: "UU",
	},
	sinistea: {
		tier: "LC",
	},
	polteageist: {
		tier: "UU",
	},
	hatenna: {
		tier: "LC",
	},
	hattrem: {
		tier: "NFE",
	},
	hatterene: {
		tier: "UU",
	},
	impidimp: {
		tier: "LC",
	},
	morgrem: {
		tier: "NFE",
	},
	grimmsnarl: {
		tier: "UU",
	},
	milcery: {
		tier: "LC",
	},
	alcremie: {
		tier: "UU",
	},
	falinks: {
		tier: "UU",
	},
	pincurchin: {
		tier: "UU",
	},
	snom: {
		tier: "LC",
	},
	frosmoth: {
		tier: "UU",
	},
	stonjourner: {
		tier: "UU",
	},
	eiscue: {
		tier: "UU",
	},
	eiscuenoice: {
		tier: "Illegal",
	},
	indeedee: {
		tier: "UU",
	},
	indeedeef: {
		tier: "UU",
	},
	morpeko: {
		tier: "UU",
	},
	morpekohangry: {
		tier: "Illegal",
	},
	cufant: {
		tier: "LC",
	},
	copperajah: {
		tier: "UU",
	},
	dracozolt: {
		tier: "UU",
	},
	arctozolt: {
		tier: "UU",
	},
	dracovish: {
		tier: "UU",
	},
	arctovish: {
		tier: "UU",
	},
	duraludon: {
		tier: "NFE",
	},
	dreepy: {
		tier: "LC",
	},
	drakloak: {
		tier: "NFE",
	},
	dragapult: {
		tier: "Uber",
	},
	zacian: {
		tier: "Uber",
	},
	zaciancrowned: {
		tier: "Illegal",
	},
	zamazenta: {
		tier: "Uber",
	},
	zamazentacrowned: {
		tier: "Illegal",
	},
	eternatus: {
		tier: "Uber",
	},
	kubfu: {
		tier: "NFE",
	},
	urshifu: {
		tier: "UU",
	},
	urshifurapidstrike: {
		tier: "UU",
	},
	zarude: {
		tier: "UU",
	},
	regieleki: {
		tier: "UU",
	},
	regidrago: {
		tier: "UU",
	},
	glastrier: {
		tier: "UU",
	},
	spectrier: {
		tier: "UU",
	},
	calyrex: {
		tier: "UU",
	},
	calyrexice: {
		tier: "Uber",
	},
	calyrexshadow: {
		tier: "Uber",
	},
	enamorus: {
		isNonstandard: null,
		tier: "UU",
	},
	enamorustherian: {
		isNonstandard: null,
		tier: "UU",
	},
	sprigatito: {
		tier: "LC",
	},
	floragato: {
		tier: "NFE",
	},
	meowscarada: {
		tier: "UU",
	},
	fuecoco: {
		tier: "LC",
	},
	crocalor: {
		tier: "NFE",
	},
	skeledirge: {
		tier: "UU",
	},
	quaxly: {
		tier: "LC",
	},
	quaxwell: {
		tier: "UU",
	},
	quaquaval: {
		tier: "UU",
	},
	lechonk: {
		tier: "LC",
	},
	oinkologne: {
		tier: "UU",
	},
	oinkolognef: {
		tier: "UU",
	},
	tarountula: {
		tier: "LC",
	},
	spidops: {
		tier: "UU",
	},
	nymble: {
		tier: "LC",
	},
	lokix: {
		tier: "UU",
	},
	rellor: {
		tier: "LC",
	},
	rabsca: {
		tier: "UU",
	},
	greavard: {
		tier: "LC",
	},
	houndstone: {
		tier: "UU",
	},
	flittle: {
		tier: "NFE",
	},
	espathra: {
		tier: "UU",
	},
	wiglett: {
		tier: "LC",
	},
	wugtrio: {
		tier: "UU",
	},
	dondozo: {
		tier: "UU",
	},
	veluza: {
		tier: "UU",
	},
	finizen: {
		tier: "LC",
	},
	palafin: {
		tier: "UU",
	},
	smoliv: {
		tier: "LC",
	},
	dolliv: {
		tier: "NFE",
	},
	arboliva: {
		tier: "UU",
	},
	capsakid: {
		tier: "LC",
	},
	scovillain: {
		tier: "UU",
	},
	tadbulb: {
		tier: "LC",
	},
	bellibolt: {
		tier: "UU",
	},
	varoom: {
		tier: "LC",
	},
	revavroom: {
		tier: "UU",
	},
	orthworm: {
		tier: "UU",
	},
	tandemaus: {
		tier: "LC",
	},
	maushold: {
		tier: "UU",
	},
	cetoddle: {
		tier: "LC",
	},
	cetitan: {
		tier: "UU",
	},
	frigibax: {
		tier: "LC",
	},
	arctibax: {
		tier: "NFE",
	},
	baxcalibur: {
		tier: "UU",
	},
	tatsugiri: {
		tier: "UU",
	},
	cyclizar: {
		tier: "UU",
	},
	pawmi: {
		tier: "LC",
	},
	pawmo: {
		tier: "NFE",
	},
	pawmot: {
		tier: "UU",
	},
	wattrel: {
		tier: "LC",
	},
	kilowattrel: {
		tier: "UU",
	},
	bombirdier: {
		tier: "UU",
	},
	squawkabilly: {
		tier: "UU",
	},
	flamigo: {
		tier: "UU",
	},
	klawf: {
		tier: "UU",
	},
	nacli: {
		tier: "LC",
	},
	naclstack: {
		tier: "UU",
	},
	garganacl: {
		tier: "UU",
	},
	glimmet: {
		tier: "LC",
	},
	glimmora: {
		tier: "UU",
	},
	shroodle: {
		tier: "LC",
	},
	grafaiai: {
		tier: "UU",
	},
	fidough: {
		tier: "LC",
	},
	dachsbun: {
		tier: "UU",
	},
	maschiff: {
		tier: "LC",
	},
	mabosstiff: {
		tier: "UU",
	},
	bramblin: {
		tier: "LC",
	},
	brambleghast: {
		tier: "UU",
	},
	gimmighoul: {
		tier: "LC",
	},
	gimmighoulroaming: {
		tier: "LC",
	},
	gholdengo: {
		tier: "UU",
	},
	greattusk: {
		tier: "OU",
	},
	brutebonnet: {
		tier: "UU",
	},
	sandyshocks: {
		tier: "UU",
	},
	screamtail: {
		tier: "OU",
	},
	fluttermane: {
		tier: "UU",
	},
	slitherwing: {
		tier: "UU",
	},
	roaringmoon: {
		tier: "UU",
	},
	irontreads: {
		tier: "OU",
	},
	ironmoth: {
		tier: "UU",
	},
	ironhands: {
		tier: "UU",
	},
	ironjugulis: {
		tier: "UU",
	},
	ironthorns: {
		tier: "UU",
	},
	ironbundle: {
		tier: "Uber",
	},
	ironvaliant: {
		tier: "Uber",
	},
	tinglu: {
		tier: "UU",
	},
	chienpao: {
		tier: "UU",
	},
	wochien: {
		tier: "UU",
	},
	chiyu: {
		tier: "UU",
	},
	koraidon: {
		tier: "Uber",
	},
	miraidon: {
		tier: "Uber",
	},
	tinkatink: {
		tier: "LC",
	},
	tinkatuff: {
		tier: "UU",
	},
	tinkaton: {
		tier: "UU",
	},
	charcadet: {
		tier: "LC",
	},
	armarouge: {
		tier: "UU",
	},
	ceruledge: {
		tier: "UU",
	},
	toedscool: {
		tier: "LC",
	},
	toedscruel: {
		tier: "UU",
	},
	kingambit: {
		tier: "UU",
	},
	clodsire: {
		tier: "UU",
	},
	annihilape: {
		tier: "UU",
	},
	walkingwake: {
		tier: "OU",
	},
	ironleaves: {
		tier: "UU",
	},
	poltchageist: {
		tier: "LC",
	},
	sinistcha: {
		tier: "UU",
	},
	okidogi: {
		tier: "UU",
	},
	munkidori: {
		tier: "UU",
	},
	fezandipiti: {
		tier: "UU",
	},
	ogerpon: {
		tier: "UU",
	},
	terapagos: {
		tier: "OU",
	},
	hydrapple: {
		tier: "OU",
	},
	ragingbolt: {
		tier: "OU",
	},
	gougingfire: {
		tier: "OU",
	},
	archaludon: {
		tier: "OU",
	},
	ironcrown: {
		tier: "OU",
	},
	ironboulder: {
		tier: "OU",
	},
};
